module.exports = __webpack_public_path__ + "img/qrcode3.361516ac.png";